document.addEventListener('DOMContentLoaded', function () {
  var picture = document.getElementById('responsive-image')
  if (!picture) return // Exit if the picture element doesn't exist

  var image = picture.querySelector('img')
  var sources = picture.querySelectorAll('source')
  var captionElement = document.getElementById('image-caption')
  var descriptionElement = document.getElementById('image-description')
  var detailsElement = document.getElementById('image-info')

  function updateImageInfo() {
    // console.log('Updating image info')
    var activeSource = null
    // Find the source that matches the media query
    for (var i = 0; i < sources.length; i++) {
      var source = sources[i]
      // console.log('Checking source:', source.media, window.matchMedia(source.media).matches)
      if (window.matchMedia(source.media).matches) {
        activeSource = source
        break
      }
    }

    // Use the active source or fallback to the image
    var activeElement = activeSource || image
    // console.log('Active element:', activeElement)

    // Get caption and description from the active element
    var caption = activeElement.getAttribute('data-caption') || ''
    var description = activeElement.getAttribute('data-description') || ''
    // console.log('Caption:', caption)
    // console.log('Description:', description)

    // Update caption if it exists
    if (captionElement) {
      captionElement.textContent = caption
      captionElement.style.display = caption ? '' : 'none'
    }

    // Update description if it exists
    if (descriptionElement) {
      descriptionElement.textContent = description
      descriptionElement.style.display = description ? '' : 'none'
    }

    // Show/hide the details element based on whether there's content
    if (detailsElement) {
      var hasContent = caption || description
      detailsElement.style.display = hasContent ? '' : 'none'
    }

    // Update aria attributes
    if (image) {
      if (caption) {
        image.setAttribute('aria-labelledby', 'image-caption')
      } else {
        image.removeAttribute('aria-labelledby')
      }
      if (description) {
        image.setAttribute('aria-describedby', 'image-description')
      } else {
        image.removeAttribute('aria-describedby')
      }
    }
  }

  // Update information on load
  updateImageInfo()

  // Update information when the screen size changes
  window.addEventListener('resize', updateImageInfo)
})

/* Kein jump bei Details */
document.addEventListener('DOMContentLoaded', function () {
  const detailsElement = document.getElementById('image-info')

  if (detailsElement) {
    let scrollPos = 0

    // Scroll-Position vor dem Toggle speichern
    detailsElement.addEventListener(
      'click',
      function (e) {
        if (e.target.tagName.toLowerCase() === 'summary') {
          scrollPos = window.scrollY
        }
      },
      true
    ) // true für Capture-Phase

    // Position nach dem Toggle wiederherstellen
    detailsElement.addEventListener('toggle', function () {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: scrollPos,
          behavior: 'instant',
        })
      })
    })
  }
})
